import {BASE_URL, HandleErrorResponse} from "./common";

export const fetchReasons = async () => {
    const endpoint = `${BASE_URL}/reasons`;

    try {
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching reason data:", error);
        throw error;
    }
}

export const createNewReason = async (requestData: any) => {
    const endpoint = `${BASE_URL}/reasons/create`;

    try {
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            body: JSON.stringify(requestData)
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return response.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

export const updateReason = async (requestData: any) => {
    const endpoint = `${BASE_URL}/reasons/${requestData.id}`;

    try {
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            body: JSON.stringify(requestData)
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return response.json();
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
}

export const deleteReason = async (id: string) => {
    const endpoint = `${BASE_URL}/reasons/${id}`;

    try {
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'DELETE'
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching reason data:", error);
        throw error;
    }
}